import React from "react";
import { FilterButton } from "./style";

const DashboardFilterButton = ({ children, onClick = () => {} }: { children: React.ReactNode, onClick?: () => void }) => (
  <FilterButton onClick={onClick} icon="fa-caret-down">
    {children}
  </FilterButton>
);

export default DashboardFilterButton;
